// メッセージMap
export const MessageMap = {
    "work_start_time": "開始時間",
    "work_end_time": "終了時間",
    "rest_minute": "休憩時間"
};
